export { default, getServerSideProps } from '@/entries/Locations';
